import { type FC, useState, useCallback, useEffect } from 'react';

import { SbSharedFavoritesNudgeToastWatcher } from './SbSharedFavoritesNudgeToastWatcher.tsx';
import { canDisplayFavoritesNudge } from '../helpers/canDisplayFavoritesNudge.ts';
import { trackItemFavoritingFeb2026Test } from 'dibs-buyer-item-favoriting/src/abTests.ts';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext.tsx';

type Props = {
    userId: string;
    isItemFavoritingFeb2026Variant?: boolean;
    isItemFavoritingFeb2026Control?: boolean;
};

const SbSharedFavoritesNudgeToast: FC<Props> = ({
    userId,
    isItemFavoritingFeb2026Variant,
    isItemFavoritingFeb2026Control,
}) => {
    const { isMobile } = useServerVarsContext();
    const [startWatch, setStartWatch] = useState(false);

    const handleStopWatch = useCallback(() => {
        setStartWatch(false);
    }, []);

    useEffect(() => {
        if (isItemFavoritingFeb2026Control && canDisplayFavoritesNudge()) {
            trackItemFavoritingFeb2026Test();
        }

        // Show for mobile OR desktop Feb2026 variant
        const shouldShowNudge = isMobile || isItemFavoritingFeb2026Variant;

        if (shouldShowNudge) {
            setStartWatch(true);
        }
    }, [isMobile, isItemFavoritingFeb2026Variant, isItemFavoritingFeb2026Control]);

    if (!startWatch) {
        return null;
    }

    return <SbSharedFavoritesNudgeToastWatcher userId={userId} onStopWatch={handleStopWatch} />;
};

export { SbSharedFavoritesNudgeToast };
